import { Component, OnInit } from "@angular/core";

@Component({
  selector: "toolbox-brand-colors",
  templateUrl: "./brand-colors.component.html",
  styleUrls: ["./brand-colors.component.scss"],
})
export class BrandColorsComponent {
  backgroundColor = "#aaa";

  get backgroundStyle(): any {
    return {
      backgroundColor: this.backgroundColor,
    };
  }
}
